module.exports = __webpack_public_path__ + "static/media/medicine.5b7900ab.svg";